import { OrderType } from '../../providers/request/order-type.enum';
import { ProjectItemType } from '../project/project-item-type.enum';
import { ProjectSectionUnitProgressSearchRequest } from '../project/project-section-unit-progress-search-request.model';
import { ProjectSectionUnitJgStatus } from './project-section-unit-jg-status.enum';

export class JgPhysicalInspUnitItemProgressSearchRequest extends ProjectSectionUnitProgressSearchRequest {
  jgSectionId?: number;
  dwTypeName?: string;
  dwTypeNameSort?: number;
  dwCodeSort?: number;
  jgFbName?: string;
  jgFbNameSort?: number;
  jgFxName?: string;
  jgFxProjectTypeCode?: string;
  jgFxProjectTypeName?: string;
  type?: ProjectItemType;
  jgInspItemCode?: string;
  jgInspItemName?: string;
  jgInspItemCodeSort?: number;
  jgRfiId?: number;
  jgRfiName?: string;
  jgHirId?: number;
  jgHirName?: string;
  jgStatus?: ProjectSectionUnitJgStatus;
  sortOrderOrder?: OrderType;
}
